export const isPlayerVisible = (state) => state.videoPlayer.playerVisible;
export const getVideo = (state) => state.videoPlayer.video;
